// @flow

import React from 'react';
import Box from 'sail/Box';
import {Callout} from 'docs/components';
import {useOverlay} from 'docs/data';
import {VSCodeButton} from 'docs/shell/sidebar/xray/VSCodeButton';
import Switch from 'sail/Switch';
import './ValidationErrors.scss';

type ValidationErrorsProps = {
  errors: Array<any>,
};

const errorItem = ({node, errors, id}) => {
  const {
    file = '<unknown file>',
    start: {line},
  } = node.location;

  const location = line ? `${file}:${line}` : file;

  return (
    <>
      <p>
        Errors in <code>{node.tag}</code> at{' '}
        <VSCodeButton path={location} label={<code>{location}</code>} />
      </p>
      <ul>
        {errors.map((error, index) => (
          <li key={index}>{error.message}</li>
        ))}
      </ul>
    </>
  );
};

export const ValidationErrors = ({errors}: ValidationErrorsProps) => {
  const [overlays, setOverlay] = useOverlay();

  return (
    <Callout type="warning" title="Validation Errors">
      <div className="ValidationErrors">
        {errors.map((error) => errorItem(error))}
      </div>

      <Box padding={{top: 16}}>
        <Switch
          size="small"
          value={overlays.errors}
          onChange={(value) => setOverlay('errors', value)}
          label="Show these errors inline in the page below"
        />
      </Box>
    </Callout>
  );
};
